import React from 'react';
import { dialogs, textFormatting, customization, view, contentEditable } from '@yola/ws-sdk';
import { HSLColor } from '@yola/yola-palette-generator';
import blocks from 'src/js/modules/blocks';
import websiteDesign from 'src/js/modules/website-design';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import ColorOption from './color-option';
import AddCustomTextColorButton from './add-custom-text-color-button';
import constants from '../constants';
import getPredefinedColorsForBlock from '../helpers/get-predefined-colors-for-block';
import setColorOption from '../helpers/set-color-option';
import restoreRange from '../helpers/restore-range';

const { getSurfaceBackground, parseHslColorString, isLightColorType, getCompiledCurrentPalette } =
  websiteDesign.helpers;
const { BLOCK_ELEMENTS } = contentEditable.constants.editableElements;
const { common } = constants;

const customColorHeader = (elementId) => {
  const { BLOCK_WITH_SURFACE_SELECTOR, SURFACE_CLASS_NAME, SURFACE_INDEX_ATTRIBUTE } =
    blocks.constants.common;
  const { variables: paletteVariables } = getCompiledCurrentPalette();
  const customColors = customization.accessors.getCustomTextColors();
  const selection = view.accessors.getSelection();
  const element = view.accessors.getLiveElement(elementId);
  const block = element.closest(BLOCK_WITH_SURFACE_SELECTOR);
  const surfaceElement = element.closest(`.${SURFACE_CLASS_NAME}`);
  const blockElement = selection.focusNode.parentNode.closest(BLOCK_ELEMENTS);

  if (!block || !surfaceElement || !blockElement) return [];

  const blockId = block.id;
  const surfaces = block.getAttribute('surfaces').split(' ');
  const surfaceIndex = surfaceElement.getAttribute(SURFACE_INDEX_ATTRIBUTE);
  const surfaceAttribute = surfaces[surfaceIndex];
  const preDefinedColors = getPredefinedColorsForBlock(
    surfaceAttribute,
    blockElement.tagName,
    paletteVariables
  );
  const blockBackground = getSurfaceBackground(surfaceAttribute, paletteVariables);

  const colorOptions = [...preDefinedColors, ...customColors].map(({ value, name }) => (
    <ColorOption
      key={`${name}_${value}`}
      color={value}
      backgroundColor={blockBackground}
      handleClick={() => {
        let cssVariableName = name;

        if (!cssVariableName) {
          cssVariableName = textFormatting.helpers.getCssVariableNameByColor(value);
        }

        restoreRange(textFormatting.accessors.getAdvancedSelection(), elementId);
        setColorOption(cssVariableName, value, elementId, blockId, surfaceAttribute);
        restoreRange(textFormatting.accessors.getAdvancedSelection(), elementId);
      }}
    />
  ));

  const bgHSL = new HSLColor(...Object.values(parseHslColorString(blockBackground)));
  const isLight = isLightColorType(bgHSL);
  const optimalContrastRatio = isLight ? common.LIGHT_THEME_CR : common.DARK_THEME_CR;

  colorOptions.push(
    <AddCustomTextColorButton
      key={`add_color_option_${Date.now()}`}
      onShowDialog={() => {
        restoreRange(textFormatting.accessors.getAdvancedSelection(), elementId);
        dialogs.operations.show(dialogTypes.ADD_CUSTOM_COLOR_DIALOG, {
          elementId,
          blockId,
          surfaceAttribute,
          backgroundColor: blockBackground,
          isLight,
          optimalContrastRatio,
        });
      }}
    />
  );

  return colorOptions;
};

export default customColorHeader;
